/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { uid } from "uid";
import { useTranslation } from "react-i18next";
import { BsController } from "react-icons/bs";
import { FaBriefcase, FaHeart, FaTag, FaTicketAlt, FaWpforms } from "react-icons/fa";
import { FiBell, FiCreditCard, FiHeadphones, FiMapPin, FiRefreshCcw, FiSearch, FiShield, FiStar } from "react-icons/fi";
import { HiOutlineFilm, HiOutlineHome } from "react-icons/hi2";
import { MdOutlineAccountBalanceWallet, MdOutlineApps, MdOutlineEvent, MdOutlineLocalOffer, MdOutlineShoppingBag, MdOutlineSportsCricket } from "react-icons/md";
import { MyContext } from "../../Context/MyProvider";
import { showTost } from "../../showTost";
import Payment from "../Payment/Payment";
import logoWithName from "../../Images/logowithname.png";
import noImage from "../../Images/no_image.png";
import DesktopUserChip from "./DesktopUserChip";

const safeParseEventData = () => {
  try {
    const localData = sessionStorage.getItem("EventData");
    return localData ? JSON.parse(localData) : null;
  } catch {
    return null;
  }
};

const OrderSummery = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { BaseUrl, paymentRes, transactionId, setPaymentRes } = useContext(MyContext);

  const [isWallet] = useState(false);
  const [myWallet, setMyWallet] = useState(0);
  const [walletUsed, setWalletUsed] = useState(0);
  const [copyWallet, setCopyWallet] = useState(0);
  const [couponList, setCouponList] = useState([]);
  const [showCouponBox, setShowCouponBox] = useState(false);
  const [selectCoupon, setSelectCoupon] = useState(null);
  const [couponCode, setCouponCode] = useState("");
  const [couponCodeId, setCouponCodeId] = useState("");
  const [couponCodeValue, setCouponCodeValue] = useState("");
  const [discountType, setDiscountType] = useState("");
  const [isApplyingCoupon, setIsApplyingCoupon] = useState(false);
  const [total, setTotal] = useState(0);
  const [showPaymentBox, setShowPaymentBox] = useState(false);
  const [refCode, setRefCode] = useState("");
  const [refApplied, setRefApplied] = useState(false);

  const data = safeParseEventData();
  const Currency = localStorage.getItem("currency") || "₹";

  const calculateTotal = () => {
    let baseTotal = Number(copyWallet || 0);
    let discount = 0;

    if (selectCoupon) {
      const couponValue = Number(selectCoupon.amt || 0);

      if (selectCoupon.discount_type === "percentage") {
        discount = (Number(data?.Totalprice || 0) * couponValue) / 100;
      }

      if (selectCoupon.discount_type === "amount") {
        discount = couponValue;
      }
    }

    discount = Math.min(discount, baseTotal);
    const afterCoupon = baseTotal - discount;
    const walletAmount = isWallet && myWallet > 0 ? Math.min(afterCoupon, myWallet) : 0;

    setWalletUsed(walletAmount);
    setTotal(Math.round(afterCoupon - walletAmount));
  };

  const handleGetCouponList = () => {
    const userId = localStorage.getItem("Userid");

    if (!userId || !data) {
      return;
    }

    axios.post(`${BaseUrl}user_api/u_couponlist.php`, {
      uid: userId,
      sponsore_id: data?.Sponsoreid ? data.Sponsoreid : "0",
    })
      .then((res) => {
        setCouponList(res?.data?.couponlist || []);
      })
      .catch((error) => {
        console.error("u_couponlist", error);
      });
  };

  useEffect(() => {
    document.body.classList.add("desktop-home-active");
    window.scrollTo(0, 0);

    const wallet = localStorage.getItem("Wallet");
    setMyWallet(Math.round(Number(wallet || 0)));
    handleGetCouponList();

    const baseTotal = Number(data?.Totalprice || 0) + Number(data?.Tax || 0);
    setCopyWallet(baseTotal);
    setTotal(baseTotal);

    return () => {
      document.body.classList.remove("desktop-home-active");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    calculateTotal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectCoupon, isWallet, copyWallet]);

  const handleSelectCoupon = (item) => {
    if (myWallet < item.min_amt) {
      return;
    }

    const userId = localStorage.getItem("Userid");

    if (!userId) {
      return;
    }

    axios.post(`${BaseUrl}user_api/u_check_coupon.php`, {
      uid: userId,
      cid: item.id,
    })
      .then((res) => {
        if (res.data.ResponseCode === "200") {
          showTost(res.data.ResponseMsg, "success");
          setSelectCoupon({ code: item.coupon_code, amt: item.coupon_val, discount_type: item?.discount_type });
          setDiscountType(item?.discount_type);
          setShowCouponBox(false);
        }
      })
      .catch((error) => {
        console.error("u_check_coupon", error);
      });
  };

  const handleCouponCodeChange = (e) => {
    const value = e.target.value.toUpperCase();
    const coupon = couponList?.find((item) => item?.coupon_code?.toUpperCase() === value);

    setCouponCode(value);
    setCouponCodeId(coupon ? coupon.id : null);
    setCouponCodeValue(coupon ? coupon?.coupon_val : null);
    setDiscountType(coupon ? coupon?.discount_type : null);
  };

  const handleApplyCouponCode = async () => {
    const userId = localStorage.getItem("Userid");

    if (!couponCode.trim()) {
      showTost("Enter coupon code", "error");
      return;
    }

    try {
      setIsApplyingCoupon(true);

      const res = await axios.post(`${BaseUrl}user_api/u_check_coupon.php`, {
        uid: userId,
        cid: couponCodeId,
      });

      if (res.data.ResponseCode === "200") {
        showTost(res.data.ResponseMsg, "success");
        setSelectCoupon({ code: couponCode.toUpperCase(), amt: couponCodeValue, discount_type: discountType });
        setShowCouponBox(false);
        setCouponCode("");
      } else {
        showTost(res.data.ResponseMsg || "Invalid coupon", "error");
      }
    } catch {
      showTost("Coupon apply failed", "error");
    } finally {
      setIsApplyingCoupon(false);
    }
  };

  useEffect(() => {
    const paymentStatus = sessionStorage.getItem("Paymentstatus");

    if (!paymentStatus) return;

    setPaymentRes(paymentStatus === "PaymentDone" ? "PaymentDone" : "PaymentFaild");
  }, [setPaymentRes]);

  useEffect(() => {
    if (!paymentRes) return;

    if (paymentRes === "PaymentDone") {
      handleBookingEvent(1);
    } else {
      sessionStorage.setItem("Amount", "0");
      sessionStorage.setItem("Paymentstatus", "");
      setPaymentRes("");
      showTost(t("Payment Faild !!"), "error");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentRes]);

  const handleBookingEvent = (id) => {
    const userId = localStorage.getItem("Userid");
    const totalAmount = sessionStorage.getItem("Amount");
    const paymentId = sessionStorage.getItem("Paymentid");
    const finalAmount = total || totalAmount;

    const bookingData = {
      uid: userId,
      eid: data?.Eventid,
      typeid: data?.Typeid,
      type: data?.Type,
      price: data?.Singleprice,
      total_ticket: data?.con,
      subtotal: data?.Totalprice,
      tax: data?.Tax,
      cou_amt: selectCoupon
        ? (
          selectCoupon.discount_type === "percentage"
            ? (data.Totalprice * selectCoupon.amt) / 100
            : selectCoupon.amt
        )
        : "0",
      total_amt: finalAmount,
      wall_amt: isWallet ? walletUsed : "0",
      p_method_id: id === 0 ? "3" : paymentId,
      transaction_id: id === 0 ? "0" : (transactionId || uid(20)),
      plimit: data?.plimit,
      sponsore_id: data?.Sponsoreid ? data.Sponsoreid : "0",
    };

    axios.post(`${BaseUrl}user_api/book_ticket.php`, bookingData)
      .then((res) => {
        showTost(res.data.ResponseMsg, "success");
        setShowPaymentBox(false);
        sessionStorage.clear();
        setPaymentRes("");
        navigate("/booking");
      })
      .catch((error) => {
        console.error("book_ticket", error);
      });
  };

  const handleConfirm = () => {
    if (total === 0) {
      handleBookingEvent(0);
      return;
    }

    setShowPaymentBox(true);
    sessionStorage.setItem("pages", "booking");
  };

  const handleApplyReferral = async () => {
    const loginId = localStorage.getItem("Userid");

    if (!refCode.trim()) {
      showTost("Enter referral code", "error");
      return;
    }

    try {
      const res = await axios.post(
        "https://yblapis.ganpatigroupbharat.com/api/auth/apply_ref_code",
        { loginId: Number(loginId), refrenceCode: refCode.trim() }
      );

      if (res.data?.success) {
        showTost("Referral code applied successfully", "success");
        setRefApplied(true);
        setRefCode("");
      } else {
        showTost(res.data?.message || "Invalid referral code", "error");
      }
    } catch {
      showTost("Referral apply failed", "error");
    }
  };

  const menuItems = [
    { label: "Home", icon: HiOutlineHome, path: "/" },
    { label: "Movies", icon: HiOutlineFilm },
    { label: "Events", icon: MdOutlineEvent, active: true },
    { label: "Sports", icon: MdOutlineSportsCricket },
    { label: "Games", icon: BsController },
    { label: "Shopping", icon: MdOutlineShoppingBag },
    { label: "Services", icon: MdOutlineApps },
    { label: "Offers", icon: MdOutlineLocalOffer },
    { label: "Bookings", icon: FaTicketAlt, path: "/booking" },
    { label: "Favorites", icon: FaHeart, path: "/favorite" },
    { label: "eWallet", icon: MdOutlineAccountBalanceWallet, path: "/wallet" },
    { label: "Forms", icon: FaWpforms, path: "/form-list" },
    { label: "Business", icon: FaBriefcase, path: "/business-user" },
    { label: "Checkout", icon: FiCreditCard, path: "/order-summery", active: true },
  ];

  const mobileBottomMenuItems = [
    { label: "Home", icon: HiOutlineHome, path: "/" },
    { label: "Forms", icon: FaWpforms, path: "/form-list" },
    { label: "Business", icon: FaBriefcase, path: "/business-user" },
    { label: "Checkout", icon: FiCreditCard, path: "/order-summery", active: true },
  ];

  const handleMenuClick = (item) => {
    if (item.path) {
      navigate(item.path);
    }
  };

  const renderSidebar = () => (
    <aside className="desktop_home_sidebar">
      <div className="desktop_home_logo">
        <img src={logoWithName} alt="Nabhiverse" />
      </div>
      <nav className="desktop_home_nav">
        {menuItems.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.label}
              className={`desktop_home_nav_item ${item.active ? "active" : ""}`}
              type="button"
              onClick={() => handleMenuClick(item)}
            >
              <Icon />
              <span>{item.label}</span>
            </button>
          );
        })}
      </nav>
      <div className="desktop_home_star_box">
        <FiStar />
        <span>nabi star</span>
        <strong>Your Stars 620</strong>
        <button type="button">View Benefits</button>
      </div>
      <div className="desktop_home_help_box">
        <FiHeadphones />
        <span>Need Help?</span>
        <p>24x7 Support</p>
        <button type="button">Contact Us</button>
      </div>
    </aside>
  );

  const couponDiscount = selectCoupon
    ? Math.round(
      selectCoupon.discount_type === "percentage"
        ? (Number(data?.Totalprice || 0) * selectCoupon.amt) / 100
        : selectCoupon.amt
    )
    : 0;

  return (
    <div className="nabhiverse_desktop_home order_summary_layout">
      {renderSidebar()}

      <main className="desktop_home_main order_summary_main">
        <header className="desktop_home_topbar order_summary_topbar">
          <div className="mobile_header_logo">
            <img src={logoWithName} alt="Nabhiverse" />
          </div>
          <div className="desktop_search_box">
            <FiSearch />
            <input type="text" placeholder="Search for apps, services, movies, events and more..." readOnly />
          </div>
          <div className="desktop_location"><FiMapPin /> Bengaluru</div>
          <DesktopUserChip />
          <button className="desktop_bell_btn" type="button" aria-label="Notifications">
            <FiBell />
            <span>3</span>
          </button>
        </header>

        <section className="order_summary_shell">
          <div className="order_summary_hero">
            <div>
              <span className="order_summary_eyebrow">Confirm and pay</span>
              <h1>{t("Order Summary")}</h1>
              <p>Review your event booking, apply available rewards, and complete payment securely.</p>
            </div>
            <div className="order_summary_total_card">
              <span>Total Payment</span>
              <strong>{Currency}{total || 0}</strong>
              <small>{data?.con || 0} ticket{Number(data?.con || 0) === 1 ? "" : "s"} selected</small>
            </div>
          </div>

          {!data ? (
            <div className="order_summary_empty">
              <FiCreditCard />
              <h2>{t("No booking selected")}</h2>
              <p>Please select tickets from an event before continuing to checkout.</p>
              <button type="button" onClick={() => navigate("/")}>Go home</button>
            </div>
          ) : (
            <div className="order_summary_grid">
              <div className="order_summary_event_card">
                <img src={data?.Eventimg || noImage} alt="" />
                <div>
                  <span>Event</span>
                  <h2>{data?.Eventtitle}</h2>
                  <p>{data?.Eventdate}</p>
                  <small><FiMapPin /> {data?.Eventaddress}</small>
                </div>
              </div>

              <div className="order_summary_panel">
                <div className="order_summary_offer_box">
                  <div className="order_summary_offer_head">
                    <div>
                      <FaTag />
                      <h3>{t("Apply Coupon")}</h3>
                    </div>
                    {selectCoupon ? (
                      <span className="order_summary_success">Applied</span>
                    ) : (
                      <button type="button" onClick={() => setShowCouponBox(true)}>View all Coupon</button>
                    )}
                  </div>
                  <div className="order_summary_input_row">
                    {!selectCoupon ? (
                      <>
                        <input type="text" value={couponCode} onChange={handleCouponCodeChange} placeholder="Enter Coupon Code" />
                        <button type="button" onClick={handleApplyCouponCode} disabled={isApplyingCoupon || !couponCode}>
                          {isApplyingCoupon ? "Applying..." : "Apply"}
                        </button>
                      </>
                    ) : (
                      <>
                        <strong>{selectCoupon.code}</strong>
                        <button
                          type="button"
                          onClick={() => {
                            setSelectCoupon(null);
                            setCouponCode("");
                            setCouponCodeId(null);
                          }}
                        >
                          {t("Remove")}
                        </button>
                      </>
                    )}
                  </div>
                </div>

                <div className="order_summary_offer_box">
                  <div className="order_summary_offer_head">
                    <div>
                      <FiStar />
                      <h3>{t("Apply Referral Code")}</h3>
                    </div>
                    {!refApplied ? (
                      <button type="button" onClick={handleApplyReferral}>{t("Apply")}</button>
                    ) : (
                      <span className="order_summary_success">Applied</span>
                    )}
                  </div>
                  <div className="order_summary_input_row">
                    <input type="text" value={refCode} disabled={refApplied} onChange={(e) => setRefCode(e.target.value.toUpperCase())} placeholder="Enter referral code" />
                  </div>
                </div>

                <div className="order_summary_price_card">
                  <h3>{t("Price details")}</h3>
                  <div><span>{t("Price")}</span><strong>{Currency}{data?.Totalprice}</strong></div>
                  <div><span>{t("Fee")}</span><strong>+{Currency}{data?.Tax}</strong></div>
                  {walletUsed > 0 && <div><span>{t("Wallet")}</span><strong>-{Currency}{walletUsed}</strong></div>}
                  {selectCoupon && <div><span>{t("Coupon")}</span><strong>-{Currency}{couponDiscount}</strong></div>}
                  <div className="order_summary_total_row"><span>{t("Total Payment")}</span><strong>{Currency}{total}</strong></div>
                </div>

                <button type="button" onClick={handleConfirm} className="order_summary_confirm_btn">{t("Confirm")}</button>
              </div>
            </div>
          )}
        </section>

        <footer className="desktop_home_footer order_summary_footer">
          <img src={logoWithName} alt="Nabhiverse" />
          <span><FiShield /> Fast & Secure Payments</span>
          <span><FiRefreshCcw /> Easy Returns</span>
          <span><FiHeadphones /> 24x7 Support</span>
          <p>(c) 2026 Nabhiverse. All Rights Reserved.</p>
        </footer>
      </main>

      <nav className="mobile_bottom_menu">
        {mobileBottomMenuItems.map((item) => {
          const Icon = item.icon;
          return (
            <button key={item.label} type="button" className={item.active ? "active" : ""} onClick={() => handleMenuClick(item)}>
              <Icon />
              <span>{item.label}</span>
            </button>
          );
        })}
      </nav>

      {showCouponBox && (
        <div onClick={() => setShowCouponBox(false)} className="order_summary_modal_overlay">
          <div onClick={(e) => e.stopPropagation()} className="coupon_box order_summary_modal_box">
            {couponList?.length > 0 ? (
              <>
                <h1>{t("Available coupons")}</h1>
                <div className="max-h-[500px] scroll-container">
                  {couponList?.map((item, index) => (
                    <div key={index} className="coupon_list">
                      <div className="flex items-center gap-[10px]">
                        <div className="coupon_image_box">
                          <img src={BaseUrl + item.c_img} className="w-[40px]" alt="" />
                        </div>
                        <div>
                          <h1>{item.coupon_title}</h1>
                          <p>{item.coupon_subtitle}</p>
                          <span>{t("Expires")} {item.expire_date}</span>
                        </div>
                      </div>
                      <button onClick={() => handleSelectCoupon(item)} className={myWallet > item.min_amt ? "is_available" : "is_disabled"}>{t("Apply")}</button>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <div className="order_summary_no_coupon">
                <FaTag />
                <div>
                  <h1>{t("No Coupons Available")}</h1>
                  <p>{t("There are currently no coupon codes available. Please check back later for new offers.")}</p>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {showPaymentBox && (
        <div onClick={() => setShowPaymentBox(false)} className="order_summary_modal_overlay">
          <div onClick={(e) => e.stopPropagation()} className="coupon_box order_summary_modal_box">
            <Payment Amount={total} setShowPaymentBox={setShowPaymentBox} />
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderSummery;
/* jshint ignore:end */
